export const Genders = [
    { id: 'm', name: 'Herr' },
    { id: 'f', name: 'Frau' },
];
